import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import getChartColorsArray from "../../../components/Common/ChartsDynamicColor";
import { getPatientcount, getPatientsByClinicId } from "service/api";
import { jwtDecode } from "jwt-decode";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

const BarChart = ({ dataColors }) => {
  const barChartColor = getChartColorsArray(dataColors);

  const [Patient, setPatient] = useState({ count: 0, data: [] });
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAllPatientsByClinicId();
  }, []);

  const getAllPatientsByClinicId = async () => {
    try {
      const token = localStorage.getItem("token");
      let response;

      if (token) {
        const decoded = jwtDecode(token);
        const clinicID = decoded?.clinicID;

        response = clinicID
          ? await getPatientsByClinicId(clinicID)
          : await getPatientcount();

        if (response?.data) {
          const patients = response.data.data || [];
          setPatient(response.data);
          processChartData(patients);
        } else {
          setPatient({ count: 0, data: [] });
        }
      }
    } catch (error) {
      console.log("Error while fetching data:", error);
      setPatient({ count: 0, data: [] });
    } finally {
      setLoading(false);
    }
  };

  const processChartData = (patients) => {
    const monthCountMap = {};
    const currentYear = dayjs().year();

    // Count patients per month using add_date (DD-MM-YYYY)
    patients.forEach((patient) => {
      const date = dayjs(patient.add_date, "DD-MM-YYYY");
      if (date.isValid() && date.year() === currentYear) {
        const month = date.format("YYYY-MM");
        monthCountMap[month] = (monthCountMap[month] || 0) + 1;
      }
    });

    // All months of current year (even if no data)
    const months = Array.from({ length: 12 }, (_, i) =>
      dayjs(`${currentYear}-${i + 1}-01`).format("YYYY-MM")
    );

    const formattedLabels = months.map((m) => dayjs(m).format("MMM"));
    const counts = months.map((m) => monthCountMap[m] || 0);

    setChartData({
      labels: formattedLabels,
      datasets: [
        {
          label: `Patients Registered (${currentYear})`,
          backgroundColor: barChartColor[0],
          borderColor: barChartColor[0],
          borderWidth: 1,
          hoverBackgroundColor: barChartColor[1],
          hoverBorderColor: barChartColor[1],
          data: counts,
        },
      ],
    });
  };

  const option = {
    scales: {
      x: {
        title: {
          display: true,
          text: "Month",
        },
      },
      y: {
        title: {
          display: true,
          text: "Number of Patients",
        },
        beginAtZero: true,
        precision: 0,
      },
    },
  };

  return (
    <div>
      {!loading && (
        <Bar width={751} height={300} data={chartData} options={option} />
      )}
    </div>
  );
};

export default BarChart;
